const ResponseConstant = {
  // ACCOUNT / COLLABORATOR
  invalid_account_error: 'INVALID_ACCOUNT_ERROR',
  account_not_found_error: 'ACCOUNT_NOT_FOUND_ERROR',
  no_multi_collaborator_account_error: 'NO_MULTI_COLLABORATOR_ACCOUNT_ERROR',
  invalid_job_type_error: 'INVALID_JOB_TYPE_ERROR',
  invalid_job_description_error: 'INVALID_JOB_DESCRIPTION_ERROR',
  invalid_sub_status_error: 'INVALID_SUB_STATUS_ERROR',
  invalid_formation_one_error: 'INVALID_FORMATION_ONE_ERROR',
  invalid_formation_two_error: 'INVALID_FORMATION_TWO_ERROR',
  invalid_formation_three_error: 'INVALID_FORMATION_THREE_ERROR',
  invalid_collaborator_error: 'INVALID_COLLABORATOR_ERROR',
  user_already_exists_error: 'USER_ALREADY_EXISTS_ERROR',
  cant_deactivated_collaborator_error: 'CANT_DEACTIVATED_COLLABORATOR_ERROR',
  collaborator_not_found_error: 'COLLABORATOR_NOT_FOUND_ERROR',
  invalid_role_type_error: 'INVALID_ROLE_TYPE_ERROR',
  invalid_duplicate_role_title_error: 'INVALID_DUPLICATE_ROLE_TITLE_ERROR',
  invalid_csrf_error: 'INVALID_CSRF_ERROR',

  // BILLING
  invalid_billing_id_error: 'INVALID_BILLING_ID_ERROR',
  billing_number_error: 'BILLING_NUMBER_ERROR',
  billing_not_found_error: 'BILLING_NOT_FOUND_ERROR',

  // COMMON / GENERIC ERRORS
  invalid_body_error: 'INVALID_BODY_ERROR',
  sms_notification_failed_error: 'SMS_NOTIFICATION_FAILED_ERROR',
  sms_service_unavailable_error: 'SMS_SERVICE_UNAVAILABLE_ERROR',
  invalid_query_param_error: 'INVALID_QUERY_PARAM_ERROR',
  invalid_request_error: 'INVALID_REQUEST_ERROR',
  unexpected_error: 'UNEXPECTED_ERROR',
  limit_reached_error: 'LIMIT_REACHED_ERROR',
  not_found_error: 'NOT_FOUND_ERROR',
  invalid_context_error: 'INVALID_CONTEXT_ERROR',
  invalid_type_error: 'INVALID_TYPE_ERROR',
  invalid_constraints_error: 'INVALID_CONSTRAINTS_ERROR',
  invalid_jwt_error: 'INVALID_JWT_ERROR',
  expired_jwt_error: 'EXPIRED_JWT_ERROR',
  invalid_captcha_token_error: 'INVALID_CAPTCHA_TOKEN_ERROR',
  invalid_token_error: 'INVALID_TOKEN_ERROR',
  login_2fa_required_error: 'LOGIN_2FA_REQUIRED_ERROR',
  invalid_login_2fa_code_error: 'INVALID_LOGIN_2FA_CODE_ERROR',
  expired_login_2fa_code_error: 'EXPIRED_LOGIN_2FA_CODE_ERROR',
  login_2fa_attempt_limit_reached_error: 'LOGIN_2FA_ATTEMPT_LIMIT_REACHED_ERROR',
  login_2fa_resend_limit_reached_error: 'LOGIN_2FA_RESEND_LIMIT_REACHED_ERROR',
  invalid_permission_configuration_error: 'INVALID_PERMISSION_CONFIGURATION_ERROR',
  invalid_permission_type_error: 'INVALID_PERMISSION_TYPE_ERROR',
  invalid_forbidden_permission_error: 'INVALID_FORBIDDEN_PERMISSION_ERROR',
  unauthorized_entity_access_error: 'UNAUTHORIZED_ENTITY_ACCESS_ERROR',
  invalid_email_error: 'INVALID_EMAIL_ERROR',
  missing_email_error: 'MISSING_EMAIL_ERROR',
  invalid_contact_email_error: 'INVALID_CONTACT_EMAIL_ERROR',
  invalid_phone_number_error: 'INVALID_PHONE_NUMBER_ERROR',
  invalid_password_error: 'INVALID_PASSWORD_ERROR',
  invalid_new_confirm_password_error: 'INVALID_NEW_CONFIRM_PASSWORD_ERROR',
  invalid_id_error: 'INVALID_ID_ERROR',
  invalid_firstname_error: 'INVALID_FIRSTNAME_ERROR',
  invalid_lastname_error: 'INVALID_LASTNAME_ERROR',
  invalid_description_error: 'INVALID_DESCRIPTION_ERROR',
  invalid_title_error: 'INVALID_TITLE_ERROR',
  invalid_comment_error: 'INVALID_COMMENT_ERROR',
  status_error: 'STATUS_ERROR',
  not_empty_list_error: 'NOT_EMPTY_LIST_ERROR',
  invalid_address_error: 'INVALID_ADDRESS_ERROR',
  departure_address_name_invalid_error: 'DEPARTURE_ADDRESS_NAME_INVALID_ERROR',
  departure_address_number_invalid_error: 'DEPARTURE_ADDRESS_NUMBER_INVALID_ERROR',
  departure_address_street_invalid_error: 'DEPARTURE_ADDRESS_STREET_INVALID_ERROR',
  departure_address_zip_code_invalid_error: 'DEPARTURE_ADDRESS_ZIP_CODE_INVALID_ERROR',
  departure_address_city_invalid_error: 'DEPARTURE_ADDRESS_CITY_INVALID_ERROR',
  departure_address_contact_email_invalid_error: 'DEPARTURE_ADDRESS_CONTACT_EMAIL_INVALID_ERROR',
  departure_address_contact_name_invalid_error: 'DEPARTURE_ADDRESS_CONTACT_NAME_INVALID_ERROR',
  departure_address_contact_phone_invalid_error: 'DEPARTURE_ADDRESS_CONTACT_PHONE_INVALID_ERROR',
  departure_address_not_found_error: 'DEPARTURE_ADDRESS_NOT_FOUND_ERROR',
  return_address_name_invalid_error: 'RETURN_ADDRESS_NAME_INVALID_ERROR',
  return_address_number_invalid_error: 'RETURN_ADDRESS_NUMBER_INVALID_ERROR',
  return_address_street_invalid_error: 'RETURN_ADDRESS_STREET_INVALID_ERROR',
  return_address_zip_code_invalid_error: 'RETURN_ADDRESS_ZIP_CODE_INVALID_ERROR',
  return_address_city_invalid_error: 'RETURN_ADDRESS_CITY_INVALID_ERROR',
  return_address_contact_email_invalid_error: 'RETURN_ADDRESS_CONTACT_EMAIL_INVALID_ERROR',
  return_address_contact_name_invalid_error: 'RETURN_ADDRESS_CONTACT_NAME_INVALID_ERROR',
  return_address_contact_phone_invalid_error: 'RETURN_ADDRESS_CONTACT_PHONE_INVALID_ERROR',
  invalid_return_address_error: 'INVALID_RETURN_ADDRESS_ERROR',
  invalid_file_to_heavy_error: 'INVALID_FILE_TO_HEAVY_ERROR',
  invalid_file_name_error: 'INVALID_FILE_NAME_ERROR',
  invalid_file_error: 'INVALID_FILE_ERROR',
  invalid_file_format_error: 'INVALID_FILE_FORMAT_ERROR',
  failed_upload_error: 'FAILED_UPLOAD_ERROR',
  cloud_storage_integrity_pending_error: 'CLOUD_STORAGE_INTEGRITY_PENDING_ERROR',

  // COMPANY / EXPORT / REGION / SUPPLIER
  invalid_company_error: 'INVALID_COMPANY_ERROR',
  invalid_company_name_error: 'INVALID_COMPANY_NAME_ERROR',
  invalid_export_type_error: 'INVALID_EXPORT_TYPE_ERROR',
  not_found_region_code_error: 'NOT_FOUND_REGION_CODE_ERROR',
  not_found_supplier_code_error: 'NOT_FOUND_SUPPLIER_CODE_ERROR',

  // GUARANTEE / PACKAGE / PRICING
  invalid_guarantee_error: 'INVALID_GUARANTEE_ERROR',
  invalid_guarantee_type_error: 'INVALID_GUARANTEE_TYPE_ERROR',
  invalid_products_guarantee_error: 'INVALID_PRODUCTS_GUARANTEE_ERROR',
  invalid_guarantee_configuration_error: 'INVALID_GUARANTEE_CONFIGURATION_ERROR',
  invalid_client_price_error: 'INVALID_CLIENT_PRICE_ERROR',
  package_watt_invalid_error: 'PACKAGE_WATT_INVALID_ERROR',
  package_ampere_invalid_error: 'PACKAGE_AMPERE_INVALID_ERROR',
  package_watt_hour_invalid_error: 'PACKAGE_WATT_HOUR_INVALID_ERROR',
  package_weight_invalid_error: 'PACKAGE_WEIGHT_INVALID_ERROR',
  package_length_invalid_error: 'PACKAGE_LENGTH_INVALID_ERROR',
  packet_width_invalid_error: 'PACKET_WIDTH_INVALID_ERROR',
  package_check_box_invalid_error: 'PACKAGE_CHECK_BOX_INVALID_ERROR',
  additional_repair_cost_error: 'ADDITIONAL_REPAIR_COST_ERROR',
  pricing_type_invalid_error: 'PRICING_TYPE_INVALID_ERROR',
  transport_cost_error: 'TRANSPORT_COST_ERROR',
  labor_cost_error: 'LABOR_COST_ERROR',
  offer_type_already_exist_error: 'OFFER_TYPE_ALREADY_EXIST_ERROR',
  offer_type_error: 'OFFER_TYPE_ERROR',
  estimate_cost_error: 'ESTIMATE_COST_ERROR',
  margin_error: 'MARGIN_ERROR',
  total_cost_error: 'TOTAL_COST_ERROR',

  // MASS IMPORT / IMPORT
  invalid_additional_repair_cost_error: 'INVALID_ADDITIONAL_REPAIR_COST_ERROR',

  // ITECH
  itech_generic_error: 'ITECH_GENERIC_ERROR',
  itech_invalid_credentials_error: 'ITECH_INVALID_CREDENTIALS_ERROR',
  itech_products_param_missing_error: 'ITECH_PRODUCTS_PARAM_MISSING_ERROR',
  itech_product_not_found_error: 'ITECH_PRODUCT_NOT_FOUND_ERROR',
  itech_client_param_missing_error: 'ITECH_CLIENT_PARAM_MISSING_ERROR',
  itech_client_not_found_error: 'ITECH_CLIENT_NOT_FOUND_ERROR',
  itech_request_code_not_found_error: 'ITECH_REQUEST_CODE_NOT_FOUND_ERROR',
  itech_invalid_format_error: 'ITECH_INVALID_FORMAT_ERROR',
  itech_table_not_found_error: 'ITECH_TABLE_NOT_FOUND_ERROR',
  itech_table_not_accessible_error: 'ITECH_TABLE_NOT_ACCESSIBLE_ERROR',
  itech_modification_not_applied_error: 'ITECH_MODIFICATION_NOT_APPLIED_ERROR',
  itech_modification_forbidden_error: 'ITECH_MODIFICATION_FORBIDDEN_ERROR',
  itech_invalid_filter_error: 'ITECH_INVALID_FILTER_ERROR',
  itech_document_integration_error: 'ITECH_DOCUMENT_INTEGRATION_ERROR',
  itech_environment_not_configured_error: 'ITECH_ENVIRONMENT_NOT_CONFIGURED_ERROR',
  itech_header_not_found_error: 'ITECH_HEADER_NOT_FOUND_ERROR',
  itech_document_lines_not_found_error: 'ITECH_DOCUMENT_LINES_NOT_FOUND_ERROR',
  itech_line_errors_present_error: 'ITECH_LINE_ERRORS_PRESENT_ERROR',
  itech_invalid_or_expired_token_error: 'ITECH_INVALID_OR_EXPIRED_TOKEN_ERROR',

  // NETWORK / GROUP / STORE
  invalid_network_error: 'INVALID_NETWORK_ERROR',
  invalid_store_error: 'INVALID_STORE_ERROR',
  invalid_client_number_error: 'INVALID_CLIENT_NUMBER_ERROR',
  not_found_client_number_error: 'NOT_FOUND_CLIENT_NUMBER_ERROR',

  // NOTIFICATION / TEMPORARY MESSAGE / EMAIL
  notification_not_found_error: 'NOTIFICATION_NOT_FOUND_ERROR',
  notification_invalid_title_error: 'NOTIFICATION_INVALID_TITLE_ERROR',
  notification_invalid_subtitle_error: 'NOTIFICATION_INVALID_SUBTITLE_ERROR',
  notification_invalid_content_error: 'NOTIFICATION_INVALID_CONTENT_ERROR',
  notification_invalid_redirection_status_error: 'NOTIFICATION_INVALID_REDIRECTION_STATUS_ERROR',
  notification_invalid_redirection_message_error: 'NOTIFICATION_INVALID_REDIRECTION_MESSAGE_ERROR',
  notification_invalid_redirection_url_error: 'NOTIFICATION_INVALID_REDIRECTION_URL_ERROR',
  not_found_temporary_message_error: 'NOT_FOUND_TEMPORARY_MESSAGE_ERROR',
  invalid_temporary_message_title_error: 'INVALID_TEMPORARY_MESSAGE_TITLE_ERROR',
  invalid_temporary_message_start_date_error: 'INVALID_TEMPORARY_MESSAGE_START_DATE_ERROR',
  invalid_temporary_message_end_date_error: 'INVALID_TEMPORARY_MESSAGE_END_DATE_ERROR',
  invalid_temporary_message_main_content_error: 'INVALID_TEMPORARY_MESSAGE_MAIN_CONTENT_ERROR',
  invalid_temporary_message_subtitle_error: 'INVALID_TEMPORARY_MESSAGE_SUBTITLE_ERROR',
  invalid_temporary_message_sub_content_error: 'INVALID_TEMPORARY_MESSAGE_SUB_CONTENT_ERROR',
  invalid_temporary_message_footer_error: 'INVALID_TEMPORARY_MESSAGE_FOOTER_ERROR',
  email_client_error: 'EMAIL_CLIENT_ERROR',
  email_preparer_error: 'EMAIL_PREPARER_ERROR',
  email_commercial_error: 'EMAIL_COMMERCIAL_ERROR',

  // PRODUCT
  invalid_manufacturer_error: 'INVALID_MANUFACTURER_ERROR',
  invalid_manufacturer_number_error: 'INVALID_MANUFACTURER_NUMBER_ERROR',
  invalid_category_error: 'INVALID_CATEGORY_ERROR',
  invalid_sub_category_error: 'INVALID_SUB_CATEGORY_ERROR',
  invalid_product_error: 'INVALID_PRODUCT_ERROR',
  invalid_boomerang_name_error: 'INVALID_BOOMERANG_NAME_ERROR',
  invalid_boomerang_id_error: 'INVALID_BOOMERANG_ID_ERROR',
  duplicate_boomerang_id_error: 'DUPLICATE_BOOMERANG_ID_ERROR',
  invalid_serial_number_error: 'INVALID_SERIAL_NUMBER_ERROR',
  invalid_update_status_date_error: 'INVALID_UPDATE_STATUS_DATE_ERROR',
  invalid_commercial_guarantee_error: 'INVALID_COMMERCIAL_GUARANTEE_ERROR',
  invalid_duplicate_email_error: 'INVALID_DUPLICATE_EMAIL_ERROR',
  invalid_breakdown_question_error: 'INVALID_BREAKDOWN_QUESTION_ERROR',
  invalid_product_breakdown_error: 'INVALID_PRODUCT_BREAKDOWN_ERROR',
  invalid_breakdown_description_error: 'INVALID_BREAKDOWN_DESCRIPTION_ERROR',

  // RECYCLING
  recycling_bac_not_found_error: 'RECYCLING_BAC_NOT_FOUND_ERROR',
  invalid_recycling_folder_boomerang_id_error: 'INVALID_RECYCLING_FOLDER_BOOMERANG_ID_ERROR',
  recycling_folder_not_found_error: 'RECYCLING_FOLDER_NOT_FOUND_ERROR',
  recycling_folder_attachment_not_found_error: 'RECYCLING_FOLDER_ATTACHMENT_NOT_FOUND_ERROR',
  invalid_recycling_folder_qr_code_token_error: 'INVALID_RECYCLING_FOLDER_QR_CODE_TOKEN_ERROR',
  recycling_boomerang_id_not_found_error: 'RECYCLING_BOOMERANG_ID_NOT_FOUND_ERROR',
  invalid_deposit_date_error: 'INVALID_DEPOSIT_DATE_ERROR',
  product_condition_not_found_error: 'PRODUCT_CONDITION_NOT_FOUND_ERROR',

  // RENTAL
  rental_file_not_found_error: 'RENTAL_FILE_NOT_FOUND_ERROR',
  invalid_rental_file_product_id_error: 'INVALID_RENTAL_FILE_PRODUCT_ID_ERROR',
  invalid_rental_file_product_availability_error: 'INVALID_RENTAL_FILE_PRODUCT_AVAILABILITY_ERROR',
  invalid_rental_file_repair_file_error: 'INVALID_RENTAL_FILE_REPAIR_FILE_ERROR',
  invalid_rental_file_company_name_error: 'INVALID_RENTAL_FILE_COMPANY_NAME_ERROR',
  invalid_rental_file_client_fullname_error: 'INVALID_RENTAL_FILE_CLIENT_FULLNAME_ERROR',
  invalid_rental_file_client_email_error: 'INVALID_RENTAL_FILE_CLIENT_EMAIL_ERROR',
  invalid_rental_file_client_phone_error: 'INVALID_RENTAL_FILE_CLIENT_PHONE_ERROR',
  invalid_rental_file_company_address_name_error: 'INVALID_RENTAL_FILE_COMPANY_ADDRESS_NAME_ERROR',
  invalid_rental_file_company_address_number_error:
    'INVALID_RENTAL_FILE_COMPANY_ADDRESS_NUMBER_ERROR',
  invalid_rental_file_company_address_street_error:
    'INVALID_RENTAL_FILE_COMPANY_ADDRESS_STREET_ERROR',
  invalid_rental_file_company_address_zip_code_error:
    'INVALID_RENTAL_FILE_COMPANY_ADDRESS_ZIP_CODE_ERROR',
  invalid_rental_file_company_address_city_error: 'INVALID_RENTAL_FILE_COMPANY_ADDRESS_CITY_ERROR',
  invalid_rental_file_company_address_country_error:
    'INVALID_RENTAL_FILE_COMPANY_ADDRESS_COUNTRY_ERROR',
  invalid_rental_file_delivery_address_name_error:
    'INVALID_RENTAL_FILE_DELIVERY_ADDRESS_NAME_ERROR',
  invalid_rental_file_delivery_address_number_error:
    'INVALID_RENTAL_FILE_DELIVERY_ADDRESS_NUMBER_ERROR',
  invalid_rental_file_delivery_address_street_error:
    'INVALID_RENTAL_FILE_DELIVERY_ADDRESS_STREET_ERROR',
  invalid_rental_file_delivery_address_zip_code_error:
    'INVALID_RENTAL_FILE_DELIVERY_ADDRESS_ZIP_CODE_ERROR',
  invalid_rental_file_delivery_address_city_error:
    'INVALID_RENTAL_FILE_DELIVERY_ADDRESS_CITY_ERROR',
  invalid_rental_file_delivery_address_country_error:
    'INVALID_RENTAL_FILE_DELIVERY_ADDRESS_COUNTRY_ERROR',
  rental_file_delivery_address_not_found_error: 'RENTAL_FILE_DELIVERY_ADDRESS_NOT_FOUND_ERROR',
  invalid_rental_file_desired_deposit_type_error: 'INVALID_RENTAL_FILE_DESIRED_DEPOSIT_TYPE_ERROR',
  rental_file_store_not_found_error: 'RENTAL_FILE_STORE_NOT_FOUND_ERROR',
  rental_file_network_not_found_error: 'RENTAL_FILE_NETWORK_NOT_FOUND_ERROR',
  invalid_rental_file_status_update_date_error: 'INVALID_RENTAL_FILE_STATUS_UPDATE_DATE_ERROR',
  rental_file_status_not_found_error: 'RENTAL_FILE_STATUS_NOT_FOUND_ERROR',
  invalid_rental_file_status_error: 'INVALID_RENTAL_FILE_STATUS_ERROR',
  invalid_rental_file_qr_code_token_error: 'INVALID_RENTAL_FILE_QR_CODE_TOKEN_ERROR',
  invalid_rental_file_qr_code_token_not_used_error:
    'INVALID_RENTAL_FILE_QR_CODE_TOKEN_NOT_USED_ERROR',
  invalid_rental_file_qr_code_collaborator_error: 'INVALID_RENTAL_FILE_QR_CODE_COLLABORATOR_ERROR',
  invalid_rental_file_force_pass_error: 'INVALID_RENTAL_FILE_FORCE_PASS_ERROR',
  rental_paginated_product_repair_file_boomerang_id_error:
    'RENTAL_PAGINATED_PRODUCT_REPAIR_FILE_BOOMERANG_ID_ERROR',
  invalid_rental_file_desired_customer_receipt_date_error:
    'INVALID_RENTAL_FILE_DESIRED_CUSTOMER_RECEIPT_DATE_ERROR',
  rental_file_rental_product_package_not_found_error:
    'RENTAL_FILE_RENTAL_PRODUCT_PACKAGE_NOT_FOUND_ERROR',
  invalid_rental_file_rental_repair_file_already_exists_error:
    'INVALID_RENTAL_FILE_RENTAL_REPAIR_FILE_ALREADY_EXISTS_ERROR',
  rental_file_rental_product_additional_cost_not_found_error:
    'RENTAL_FILE_RENTAL_PRODUCT_ADDITIONAL_COST_NOT_FOUND_ERROR',
  invalid_rental_file_status_transport_go_tracking_number_error:
    'INVALID_RENTAL_FILE_STATUS_TRANSPORT_GO_TRACKING_NUMBER_ERROR',
  invalid_rental_file_status_transport_go_transport_type_error:
    'INVALID_RENTAL_FILE_STATUS_TRANSPORT_GO_TRANSPORT_TYPE_ERROR',
  rental_file_attachment_rental_file_not_found_error:
    'RENTAL_FILE_ATTACHMENT_RENTAL_FILE_NOT_FOUND_ERROR',

  // REPAIRER / REPAIR CENTER
  invalid_repairer_error: 'INVALID_REPAIRER_ERROR',
  invalid_repairer_repair_file_number_error: 'INVALID_REPAIRER_REPAIR_FILE_NUMBER_ERROR',
  invalid_repairer_support_number_error: 'INVALID_REPAIRER_SUPPORT_NUMBER_ERROR',
  alternative_repair_center_not_found_error: 'ALTERNATIVE_REPAIR_CENTER_NOT_FOUND_ERROR',
  too_many_repair_center_found_error: 'TOO_MANY_REPAIR_CENTER_FOUND_ERROR',

  // REPAIR FILE
  repair_file_not_found_error: 'REPAIR_FILE_NOT_FOUND_ERROR',
  repair_file_repair_center_not_found_error: 'REPAIR_FILE_REPAIR_CENTER_NOT_FOUND_ERROR',
  repair_file_comment_not_found_error: 'REPAIR_FILE_COMMENT_NOT_FOUND_ERROR',
  repair_file_prospect_picture_not_found_error: 'REPAIR_FILE_PROSPECT_PICTURE_NOT_FOUND_ERROR',
  repair_file_prospect_document_not_found_error: 'REPAIR_FILE_PROSPECT_DOCUMENT_NOT_FOUND_ERROR',
  repair_file_status_detail_error: 'REPAIR_FILE_STATUS_DETAIL_ERROR',
  repair_file_store_erp_internal_error: 'REPAIR_FILE_STORE_ERP_INTERNAL_ERROR',
  repair_file_attachment_type_error: 'REPAIR_FILE_ATTACHMENT_TYPE_ERROR',
  repair_file_attachment_not_found_error: 'REPAIR_FILE_ATTACHMENT_NOT_FOUND_ERROR',
  unsupported_attachment_type_error: 'UNSUPPORTED_ATTACHMENT_TYPE_ERROR',
  repair_file_status_client_takeover_type_error: 'REPAIR_FILE_STATUS_CLIENT_TAKEOVER_TYPE_ERROR',
  invalid_track_number_error: 'INVALID_TRACK_NUMBER_ERROR',
  invalid_repair_file_status_detail_error: 'INVALID_REPAIR_FILE_STATUS_DETAIL_ERROR',
  product_buy_file_proof_error: 'PRODUCT_BUY_FILE_PROOF_ERROR',
  product_guarantee_extension_file_proof_error: 'PRODUCT_GUARANTEE_EXTENSION_FILE_PROOF_ERROR',
  product_force_support_file_proof_error: 'PRODUCT_FORCE_SUPPORT_FILE_PROOF_ERROR',
  product_end_status_invalid_error: 'PRODUCT_END_STATUS_INVALID_ERROR',
  product_boomerang_id_invalid_error: 'PRODUCT_BOOMERANG_ID_INVALID_ERROR',
  product_end_cost_invalid_error: 'PRODUCT_END_COST_INVALID_ERROR',
  invalid_repair_file_boomerang_id_error: 'INVALID_REPAIR_FILE_BOOMERANG_ID_ERROR',
  invalid_rep_number_error: 'INVALID_REP_NUMBER_ERROR',
  invalid_rep_code_error: 'INVALID_REP_CODE_ERROR',
  invalid_repairer_expedition_date_error: 'INVALID_REPAIRER_EXPEDITION_DATE_ERROR',
  invalid_repair_file_limit_date_error: 'INVALID_REPAIR_FILE_LIMIT_DATE_ERROR',
  invalid_repair_file_manual_status_update_error: 'INVALID_REPAIR_FILE_MANUAL_STATUS_UPDATE_ERROR',
  leave_reason_invalid_error: 'LEAVE_REASON_INVALID_ERROR',
  invalid_repair_file_qr_code_token_error: 'INVALID_REPAIR_FILE_QR_CODE_TOKEN_ERROR',
  invalid_purchase_order_number_error: 'INVALID_PURCHASE_ORDER_NUMBER_ERROR',
  invalid_callback_ref_error: 'INVALID_CALLBACK_REF_ERROR',
  invalid_internal_command_number_error: 'INVALID_INTERNAL_COMMAND_NUMBER_ERROR',
  prospect_contact_email_error: 'PROSPECT_CONTACT_EMAIL_ERROR',
  prospect_additional_info_error: 'PROSPECT_ADDITIONAL_INFO_ERROR',
  invalid_prospect_manufacturer_info_comment_error:
    'INVALID_PROSPECT_MANUFACTURER_INFO_COMMENT_ERROR',
  invalid_prospect_manufacturer_info_option_error:
    'INVALID_PROSPECT_MANUFACTURER_INFO_OPTION_ERROR',
  repairer_estimate_already_exist_error: 'REPAIRER_ESTIMATE_ALREADY_EXIST_ERROR',
  repairer_estimate_not_found_error: 'REPAIRER_ESTIMATE_NOT_FOUND_ERROR',
  repairer_estimate_option_error: 'REPAIRER_ESTIMATE_OPTION_ERROR',
  invalid_repairer_estimate_email_token_error: 'INVALID_REPAIRER_ESTIMATE_EMAIL_TOKEN_ERROR',
  invalid_repair_file_rating_error: 'INVALID_REPAIR_FILE_RATING_ERROR',
  invalid_repair_file_questionnaire_redirect_url_error:
    'INVALID_REPAIR_FILE_QUESTIONNAIRE_REDIRECT_URL_ERROR',
  invalid_rating_email_token_error: 'INVALID_RATING_EMAIL_TOKEN_ERROR',
  invalid_repair_file_mail_content_error: 'INVALID_REPAIR_FILE_MAIL_CONTENT_ERROR',
  invalid_document_list_error: 'INVALID_DOCUMENT_LIST_ERROR',
  repair_file_status_client_phone_notification_type_error:
    'REPAIR_FILE_STATUS_CLIENT_PHONE_NOTIFICATION_TYPE_ERROR',
  invalid_prospect_manufacturer_info_support_number_error:
    'INVALID_PROSPECT_MANUFACTURER_INFO_SUPPORT_NUMBER_ERROR',

  // SUCCESS
  valid_account_creation_ack_key: 'VALID_ACCOUNT_CREATION_ACK_KEY',
  valid_account_deletion_key: 'VALID_ACCOUNT_DELETION_KEY',
  valid_collaborator_deactivation_key: 'VALID_COLLABORATOR_DEACTIVATION_KEY',
  valid_forgot_password_key: 'VALID_FORGOT_PASSWORD_KEY',
  valid_reset_account_password_key: 'VALID_RESET_ACCOUNT_PASSWORD_KEY',
  valid_update_account_password_key: 'VALID_UPDATE_ACCOUNT_PASSWORD_KEY',
  valid_initialization_account_password_key: 'VALID_INITIALIZATION_ACCOUNT_PASSWORD_KEY',
  valid_role_deletion_key: 'VALID_ROLE_DELETION_KEY',
  valid_network_deactivation_key: 'VALID_NETWORK_DEACTIVATION_KEY',
  valid_network_reactivation_key: 'VALID_NETWORK_REACTIVATION_KEY',
  network_success_export_key: 'NETWORK_SUCCESS_EXPORT_KEY',
  valid_group_deletion_key: 'VALID_GROUP_DELETION_KEY',
  group_success_export_key: 'GROUP_SUCCESS_EXPORT_KEY',
  valid_key_account_group_deletion_key: 'VALID_KEY_ACCOUNT_GROUP_DELETION_KEY',
  key_account_group_success_export_key: 'KEY_ACCOUNT_GROUP_SUCCESS_EXPORT_KEY',
  valid_store_deactivation_key: 'VALID_STORE_DEACTIVATION_KEY',
  valid_operating_center_deactivation_key: 'VALID_OPERATING_CENTER_DEACTIVATION_KEY',
  valid_store_export_key: 'VALID_STORE_EXPORT_KEY',
  valid_operating_center_export_key: 'VALID_OPERATING_CENTER_EXPORT_KEY',
  valid_key_account_network_deactivation_key: 'VALID_KEY_ACCOUNT_NETWORK_DEACTIVATION_KEY',
  valid_key_account_network_reactivation_key: 'VALID_KEY_ACCOUNT_NETWORK_REACTIVATION_KEY',
  key_account_network_success_export_key: 'KEY_ACCOUNT_NETWORK_SUCCESS_EXPORT_KEY',
  valid_manufacturer_deactivation_key: 'VALID_MANUFACTURER_DEACTIVATION_KEY',
  valid_whitelist_update_key: 'VALID_WHITELIST_UPDATE_KEY',
  valid_category_export_key: 'VALID_CATEGORY_EXPORT_KEY',
  valid_category_delete_key: 'VALID_CATEGORY_DELETE_KEY',
  valid_sub_category_delete_key: 'VALID_SUB_CATEGORY_DELETE_KEY',
  product_success_export_key: 'PRODUCT_SUCCESS_EXPORT_KEY',
  product_creation_request_success_key: 'PRODUCT_CREATION_REQUEST_SUCCESS_KEY',
  valid_product_breakdown_associate_key: 'VALID_PRODUCT_BREAKDOWN_ASSOCIATE_KEY',
  valid_guarantee_deletion_key: 'VALID_GUARANTEE_DELETION_KEY',
  valid_repairer_delete_key: 'VALID_REPAIRER_DELETE_KEY',
  repairer_success_export_key: 'REPAIRER_SUCCESS_EXPORT_KEY',
  valid_repair_center_link_manufacturer_deletion_key:
    'VALID_REPAIR_CENTER_LINK_MANUFACTURER_DELETION_KEY',
  valid_repair_center_link_category_deletion_key: 'VALID_REPAIR_CENTER_LINK_CATEGORY_DELETION_KEY',
  valid_repair_center_link_sub_category_deletion_key:
    'VALID_REPAIR_CENTER_LINK_SUB_CATEGORY_DELETION_KEY',
  valid_repair_center_link_store_deletion_key: 'VALID_REPAIR_CENTER_LINK_STORE_DELETION_KEY',
  valid_repair_center_link_operating_center_deletion_key:
    'VALID_REPAIR_CENTER_LINK_OPERATING_CENTER_DELETION_KEY',
  valid_repair_center_link_creation_key: 'VALID_REPAIR_CENTER_LINK_CREATION_KEY',
  valid_repair_center_link_deletion_key: 'VALID_REPAIR_CENTER_LINK_DELETION_KEY',
  valid_repair_center_link_edition_key: 'VALID_REPAIR_CENTER_LINK_EDITION_KEY',
  valid_repair_center_delete_key: 'VALID_REPAIR_CENTER_DELETE_KEY',
  valid_update_repair_file_key: 'VALID_UPDATE_REPAIR_FILE_KEY',
  valid_repair_file_deleted_key: 'VALID_REPAIR_FILE_DELETED_KEY',
  valid_repair_file_closed_key: 'VALID_REPAIR_FILE_CLOSED_KEY',
  valid_repair_file_add_attachment_key: 'VALID_REPAIR_FILE_ADD_ATTACHMENT_KEY',
  valid_repair_file_relaunch_customer_key: 'VALID_REPAIR_FILE_RELAUNCH_CUSTOMER_KEY',
  valid_repair_file_manual_status_update_key: 'VALID_REPAIR_FILE_MANUAL_STATUS_UPDATE_KEY',
  valid_email_send_transport_repairer_key: 'VALID_EMAIL_SEND_TRANSPORT_REPAIRER_KEY',
  valid_email_send_client_ack_key: 'VALID_EMAIL_SEND_CLIENT_ACK_KEY',
  valid_email_send_client_and_repairer_ack_key: 'VALID_EMAIL_SEND_CLIENT_AND_REPAIRER_ACK_KEY',
  valid_prospect_document_added_key: 'VALID_PROSPECT_DOCUMENT_ADDED_KEY',
  valid_prospect_document_removed_key: 'VALID_PROSPECT_DOCUMENT_REMOVED_KEY',
  valid_prospect_picture_added_key: 'VALID_PROSPECT_PICTURE_ADDED_KEY',
  valid_prospect_picture_added_with_error_key: 'VALID_PROSPECT_PICTURE_ADDED_WITH_ERROR_KEY',
  valid_prospect_picture_removed_key: 'VALID_PROSPECT_PICTURE_REMOVED_KEY',
  valid_remove_attachment_file_key: 'VALID_REMOVE_ATTACHMENT_FILE_KEY',
  valid_add_attachment_file_key: 'VALID_ADD_ATTACHMENT_FILE_KEY',
  valid_comment_deleted_key: 'VALID_COMMENT_DELETED_KEY',
  valid_attachment_deleted_key: 'VALID_ATTACHMENT_DELETED_KEY',
  valid_repair_file_token_removed_key: 'VALID_REPAIR_FILE_TOKEN_REMOVED_KEY',
  valid_add_purchase_order_attachment_key: 'VALID_ADD_PURCHASE_ORDER_ATTACHMENT_KEY',
  valid_repair_file_estimation_option_deletion_key:
    'VALID_REPAIR_FILE_ESTIMATION_OPTION_DELETION_KEY',
  valid_repair_file_estimation_key: 'VALID_REPAIR_FILE_ESTIMATION_KEY',
  valid_repair_file_document_by_email_key: 'VALID_REPAIR_FILE_DOCUMENT_BY_EMAIL_KEY',
  valid_expressist_transporter_deletion_key: 'VALID_EXPRESSIST_TRANSPORTER_DELETION_KEY',
  valid_expressist_transporter_connexion_creation_key:
    'VALID_EXPRESSIST_TRANSPORTER_CONNEXION_CREATION_KEY',
  valid_expressist_transporter_connexion_deletion_key:
    'VALID_EXPRESSIST_TRANSPORTER_CONNEXION_DELETION_KEY',
  valid_expressist_transporter_connexion_link_deletion_key:
    'VALID_EXPRESSIST_TRANSPORTER_CONNEXION_LINK_DELETION_KEY',
  valid_notification_creation_key: 'VALID_NOTIFICATION_CREATION_KEY',
  valid_create_temporary_message_key: 'VALID_CREATE_TEMPORARY_MESSAGE_KEY',
  valid_update_temporary_message_key: 'VALID_UPDATE_TEMPORARY_MESSAGE_KEY',
  valid_email_send_key: 'VALID_EMAIL_SEND_KEY',
  valid_region_code_creation_key: 'VALID_REGION_CODE_CREATION_KEY',
  valid_region_code_update_key: 'VALID_REGION_CODE_UPDATE_KEY',
  valid_analyze_nameplate_key: 'VALID_ANALYZE_NAMEPLATE_KEY',
  valid_rental_product_update_key: 'VALID_RENTAL_PRODUCT_UPDATE_KEY',
  valid_rental_file_add_attachment_key: 'VALID_RENTAL_FILE_ADD_ATTACHMENT_KEY',
  valid_rental_file_status_update_key: 'VALID_RENTAL_FILE_STATUS_UPDATE_KEY',
  valid_recycler_deletion_key: 'VALID_RECYCLER_DELETION_KEY',
  valid_recycler_center_deletion_key: 'VALID_RECYCLER_CENTER_DELETION_KEY',
  valid_recycler_center_link_deletion_key: 'VALID_RECYCLER_CENTER_LINK_DELETION_KEY',
  valid_recycler_center_link_store_deletion_key: 'VALID_RECYCLER_CENTER_LINK_STORE_DELETION_KEY',
  valid_recycler_bac_deletion_key: 'VALID_RECYCLER_BAC_DELETION_KEY',
  valid_reconditioner_deletion_key: 'VALID_RECONDITIONER_DELETION_KEY',
  valid_reconditioner_center_deletion_key: 'VALID_RECONDITIONER_CENTER_DELETION_KEY',
  valid_reconditioner_center_link_deletion_key: 'VALID_RECONDITIONER_CENTER_LINK_DELETION_KEY',
  valid_reconditioner_center_link_store_deletion_key:
    'VALID_RECONDITIONER_CENTER_LINK_STORE_DELETION_KEY',
  valid_recycling_folder_attachment_added_key: 'VALID_RECYCLING_FOLDER_ATTACHMENT_ADDED_KEY',
  valid_recycling_folder_attachment_removed_key: 'VALID_RECYCLING_FOLDER_ATTACHMENT_REMOVED_KEY',
  valid_recycling_folder_token_removed_key: 'VALID_RECYCLING_FOLDER_TOKEN_REMOVED_KEY',
  valid_import_file_key: 'VALID_IMPORT_FILE_KEY',
  valid_export_file_task_scheduled_key: 'VALID_EXPORT_FILE_TASK_SCHEDULED_KEY',
  valid_additional_repair_cost_export_key: 'VALID_ADDITIONAL_REPAIR_COST_EXPORT_KEY',
  valid_additional_repair_cost_import_key: 'VALID_ADDITIONAL_REPAIR_COST_IMPORT_KEY',
  valid_transport_package_export_key: 'VALID_TRANSPORT_PACKAGE_EXPORT_KEY',
  valid_transport_package_import_key: 'VALID_TRANSPORT_PACKAGE_IMPORT_KEY',
  valid_transporter_export_key: 'VALID_TRANSPORTER_EXPORT_KEY',
  valid_transporter_import_key: 'VALID_TRANSPORTER_IMPORT_KEY',
  valid_estimate_transporter_cost_export_key: 'VALID_ESTIMATE_TRANSPORTER_COST_EXPORT_KEY',
  valid_estimate_transporter_cost_import_key: 'VALID_ESTIMATE_TRANSPORTER_COST_IMPORT_KEY',
  valid_package_export_key: 'VALID_PACKAGE_EXPORT_KEY',
  valid_package_import_key: 'VALID_PACKAGE_IMPORT_KEY',
  valid_model_serial_number_export_key: 'VALID_MODEL_SERIAL_NUMBER_EXPORT_KEY',
  valid_model_serial_number_import_key: 'VALID_MODEL_SERIAL_NUMBER_IMPORT_KEY',
  valid_guarantee_extension_export_key: 'VALID_GUARANTEE_EXTENSION_EXPORT_KEY',
  valid_guarantee_extension_import_key: 'VALID_GUARANTEE_EXTENSION_IMPORT_KEY',
  valid_guarantee_export_key: 'VALID_GUARANTEE_EXPORT_KEY',
  valid_guarantee_import_key: 'VALID_GUARANTEE_IMPORT_KEY',
  valid_product_breakdown_export_key: 'VALID_PRODUCT_BREAKDOWN_EXPORT_KEY',
  valid_product_breakdown_import_key: 'VALID_PRODUCT_BREAKDOWN_IMPORT_KEY',
  valid_product_distributor_ref_export_key: 'VALID_PRODUCT_DISTRIBUTOR_REF_EXPORT_KEY',
  valid_product_distributor_ref_import_key: 'VALID_PRODUCT_DISTRIBUTOR_REF_IMPORT_KEY',
  valid_product_store_price_export_key: 'VALID_PRODUCT_STORE_PRICE_EXPORT_KEY',
  valid_product_store_price_import_key: 'VALID_PRODUCT_STORE_PRICE_IMPORT_KEY',
  valid_recycler_bac_export_key: 'VALID_RECYCLER_BAC_EXPORT_KEY',
  valid_recycler_bac_import_key: 'VALID_RECYCLER_BAC_IMPORT_KEY',
  valid_recycling_buyback_price_export_key: 'VALID_RECYCLING_BUYBACK_PRICE_EXPORT_KEY',
  valid_recycling_buyback_price_import_key: 'VALID_RECYCLING_BUYBACK_PRICE_IMPORT_KEY',
  valid_recycling_client_link_export_key: 'VALID_RECYCLING_CLIENT_LINK_EXPORT_KEY',
  valid_recycling_client_link_import_key: 'VALID_RECYCLING_CLIENT_LINK_IMPORT_KEY',
  valid_rental_product_aggregate_export_key: 'VALID_RENTAL_PRODUCT_AGGREGATE_EXPORT_KEY',
  valid_rental_product_aggregate_import_key: 'VALID_RENTAL_PRODUCT_AGGREGATE_IMPORT_KEY',
  valid_product_aggregate_export_key: 'VALID_PRODUCT_AGGREGATE_EXPORT_KEY',
  valid_product_aggregate_import_key: 'VALID_PRODUCT_AGGREGATE_IMPORT_KEY',

  // TRANSPORTER / SHIPPING / EXPRESSIST
  transporter_type_invalid_error: 'TRANSPORTER_TYPE_INVALID_ERROR',
  transporter_modality_invalid_error: 'TRANSPORTER_MODALITY_INVALID_ERROR',
  transporter_name_invalid_error: 'TRANSPORTER_NAME_INVALID_ERROR',
  transporter_expressist_invalid_error: 'TRANSPORTER_EXPRESSIST_INVALID_ERROR',
  transporter_expressist_not_found_error: 'TRANSPORTER_EXPRESSIST_NOT_FOUND_ERROR',
  shipping_collect_date_invalid_error: 'SHIPPING_COLLECT_DATE_INVALID_ERROR',
  shipping_collect_status_invalid_error: 'SHIPPING_COLLECT_STATUS_INVALID_ERROR',
  invalid_real_delivery_date_error: 'INVALID_REAL_DELIVERY_DATE_ERROR',
  invalid_delivery_update_action_type_error: 'INVALID_DELIVERY_UPDATE_ACTION_TYPE_ERROR',
  expressist_transporter_store_not_found_error: 'EXPRESSIST_TRANSPORTER_STORE_NOT_FOUND_ERROR',
  chronopost_shipment_parsing_error: 'CHRONOPOST_SHIPMENT_PARSING_ERROR',
  expressist_transporter_connexion_invalid_service_error:
    'EXPRESSIST_TRANSPORTER_CONNEXION_INVALID_SERVICE_ERROR',
  expressist_transporter_connexion_invalid_login_error:
    'EXPRESSIST_TRANSPORTER_CONNEXION_INVALID_LOGIN_ERROR',
  expressist_transporter_connexion_invalid_password_error:
    'EXPRESSIST_TRANSPORTER_CONNEXION_INVALID_PASSWORD_ERROR',
  expressist_transporter_network_not_found_error: 'EXPRESSIST_TRANSPORTER_NETWORK_NOT_FOUND_ERROR',
  expressist_transporter_link_priority_error: 'EXPRESSIST_TRANSPORTER_LINK_PRIORITY_ERROR',

  // REFERENCE API - CATEGORY
  category_has_products_error: 'CATEGORY_HAS_PRODUCTS_ERROR',

  // REFERENCE API - COMMON
  file_not_found_error: 'FILE_NOT_FOUND_ERROR',
  duplicate_name_error: 'DUPLICATE_NAME_ERROR',

  // REFERENCE API - ESTIMATE TRANSPORTER COST
  estimate_transporter_cost_not_found_error: 'ESTIMATE_TRANSPORTER_COST_NOT_FOUND_ERROR',

  // REFERENCE API - EXPRESSIST TRANSPORTER CONNEXION
  expressist_transporter_connexion_not_found_error:
    'EXPRESSIST_TRANSPORTER_CONNEXION_NOT_FOUND_ERROR',
  expressist_transporter_connexion_has_links_error:
    'EXPRESSIST_TRANSPORTER_CONNEXION_HAS_LINKS_ERROR',
  expressist_transporter_connexion_duplicate_special_type_error:
    'EXPRESSIST_TRANSPORTER_CONNEXION_DUPLICATE_SPECIAL_TYPE_ERROR',

  // REFERENCE API - EXPRESSIST TRANSPORTER CONNEXION LINK
  expressist_transporter_connexion_link_not_found_error:
    'EXPRESSIST_TRANSPORTER_CONNEXION_LINK_NOT_FOUND_ERROR',
  expressist_transporter_connexion_link_already_exists_error:
    'EXPRESSIST_TRANSPORTER_CONNEXION_LINK_ALREADY_EXISTS_ERROR',
  expressist_transporter_connexion_link_store_not_found_error:
    'EXPRESSIST_TRANSPORTER_CONNEXION_LINK_STORE_NOT_FOUND_ERROR',
  expressist_transporter_connexion_link_network_not_found_error:
    'EXPRESSIST_TRANSPORTER_CONNEXION_LINK_NETWORK_NOT_FOUND_ERROR',
  expressist_transporter_connexion_link_key_account_network_not_found_error:
    'EXPRESSIST_TRANSPORTER_CONNEXION_LINK_KEY_ACCOUNT_NETWORK_NOT_FOUND_ERROR',
  expressist_transporter_connexion_link_operating_center_not_found_error:
    'EXPRESSIST_TRANSPORTER_CONNEXION_LINK_OPERATING_CENTER_NOT_FOUND_ERROR',

  // REFERENCE API - EXPRESSIST TRANSPORTER
  expressist_transporter_not_found_error: 'EXPRESSIST_TRANSPORTER_NOT_FOUND_ERROR',
  expressist_transporter_has_connexions_error: 'EXPRESSIST_TRANSPORTER_HAS_CONNEXIONS_ERROR',
  expressist_transporter_duplicate_type_error: 'EXPRESSIST_TRANSPORTER_DUPLICATE_TYPE_ERROR',

  // REFERENCE API - GROUP
  group_not_found_error: 'GROUP_NOT_FOUND_ERROR',
  group_number_already_used_error: 'GROUP_NUMBER_ALREADY_USED_ERROR',
  group_number_not_available_error: 'GROUP_NUMBER_NOT_AVAILABLE_ERROR',
  no_more_group_number_available_error: 'NO_MORE_GROUP_NUMBER_AVAILABLE_ERROR',

  // REFERENCE API - GUARANTEE
  guarantee_not_found_error: 'GUARANTEE_NOT_FOUND_ERROR',
  guarantee_invalid_sub_category_error: 'GUARANTEE_INVALID_SUB_CATEGORY_ERROR',
  guarantee_invalid_network_error: 'GUARANTEE_INVALID_NETWORK_ERROR',
  guarantee_invalid_product_type_error: 'GUARANTEE_INVALID_PRODUCT_TYPE_ERROR',
  guarantee_duplicate_type_error: 'GUARANTEE_DUPLICATE_TYPE_ERROR',

  // REFERENCE API - GUARANTEE EXTENSION
  guarantee_extension_not_found_error: 'GUARANTEE_EXTENSION_NOT_FOUND_ERROR',
  guarantee_extension_invalid_product_error: 'GUARANTEE_EXTENSION_INVALID_PRODUCT_ERROR',
  guarantee_extension_invalid_serial_number_error:
    'GUARANTEE_EXTENSION_INVALID_SERIAL_NUMBER_ERROR',

  // REFERENCE API - MANUFACTURER
  manufacturer_not_found_error: 'MANUFACTURER_NOT_FOUND_ERROR',
  manufacturer_has_products_error: 'MANUFACTURER_HAS_PRODUCTS_ERROR',

  // REFERENCE API - MODEL SERIAL NUMBER
  model_serial_number_not_found_error: 'MODEL_SERIAL_NUMBER_NOT_FOUND_ERROR',
  model_serial_number_product_type_not_found_error:
    'MODEL_SERIAL_NUMBER_PRODUCT_TYPE_NOT_FOUND_ERROR',

  // REFERENCE API - NETWORK
  network_not_found_error: 'NETWORK_NOT_FOUND_ERROR',
  key_account_network_not_found_error: 'KEY_ACCOUNT_NETWORK_NOT_FOUND_ERROR',
  key_account_group_not_found_error: 'KEY_ACCOUNT_GROUP_NOT_FOUND_ERROR',
  key_account_group_number_already_used_error: 'GROUP_NUMBER_ALREADY_USED_ERROR',
  key_account_group_number_not_available_error: 'GROUP_NUMBER_NOT_AVAILABLE_ERROR',
  no_more_key_account_group_number_available_error: 'NO_MORE_GROUP_NUMBER_AVAILABLE_ERROR',

  // REFERENCE API - PACKAGE
  package_not_found_error: 'PACKAGE_NOT_FOUND_ERROR',

  // REFERENCE API - PRODUCT BREAKDOWN
  product_breakdown_not_found_error: 'PRODUCT_BREAKDOWN_NOT_FOUND_ERROR',
  product_breakdown_invalid_manufacturer_error: 'PRODUCT_BREAKDOWN_INVALID_MANUFACTURER_ERROR',
  product_breakdown_invalid_product_error: 'PRODUCT_BREAKDOWN_INVALID_PRODUCT_ERROR',
  product_breakdown_invalid_sub_category_error: 'PRODUCT_BREAKDOWN_INVALID_SUB_CATEGORY_ERROR',
  product_breakdown_already_associated_error: 'PRODUCT_BREAKDOWN_ALREADY_ASSOCIATED_ERROR',
  product_breakdown_not_associated_error: 'PRODUCT_BREAKDOWN_NOT_ASSOCIATED_ERROR',

  // REFERENCE API - PRODUCT
  product_not_found_error: 'PRODUCT_NOT_FOUND_ERROR',
  product_invalid_manufacturer_error: 'PRODUCT_INVALID_MANUFACTURER_ERROR',
  product_invalid_category_error: 'PRODUCT_INVALID_CATEGORY_ERROR',
  product_invalid_sub_category_error: 'PRODUCT_INVALID_SUB_CATEGORY_ERROR',
  product_invalid_type_error: 'PRODUCT_INVALID_TYPE_ERROR',
  product_image_required_error: 'PRODUCT_IMAGE_REQUIRED_ERROR',
  product_sub_product_not_found_error: 'PRODUCT_SUB_PRODUCT_NOT_FOUND_ERROR',
  product_sub_product_already_exists_error: 'PRODUCT_SUB_PRODUCT_ALREADY_EXISTS_ERROR',
  product_version_not_found_error: 'PRODUCT_VERSION_NOT_FOUND_ERROR',

  // REFERENCE API - PRODUCT QUESTION
  product_question_not_found_error: 'PRODUCT_QUESTION_NOT_FOUND_ERROR',
  product_question_max_questions_error: 'PRODUCT_QUESTION_MAX_QUESTIONS_ERROR',

  // REFERENCE API - RECONDITIONER
  reconditioner_not_found_error: 'RECONDITIONER_NOT_FOUND_ERROR',
  reconditioner_center_not_found_error: 'RECONDITIONER_CENTER_NOT_FOUND_ERROR',
  reconditioner_center_link_not_found_error: 'RECONDITIONER_CENTER_LINK_NOT_FOUND_ERROR',
  reconditioner_center_link_store_not_found_error:
    'RECONDITIONER_CENTER_LINK_STORE_NOT_FOUND_ERROR',

  // REFERENCE API - RECYCLER
  recycler_not_found_error: 'RECYCLER_NOT_FOUND_ERROR',
  recycler_center_not_found_error: 'RECYCLER_CENTER_NOT_FOUND_ERROR',
  recycler_center_link_not_found_error: 'RECYCLER_CENTER_LINK_NOT_FOUND_ERROR',
  recycler_center_link_store_not_found_error: 'RECYCLER_CENTER_LINK_STORE_NOT_FOUND_ERROR',
  recycler_bac_not_found_error: 'RECYCLER_BAC_NOT_FOUND_ERROR',
  recycler_bac_has_centers_error: 'RECYCLER_BAC_HAS_CENTERS_ERROR',
  network_not_found_for_link_error: 'NETWORK_NOT_FOUND_FOR_LINK_ERROR',
  store_not_found_for_link_error: 'STORE_NOT_FOUND_FOR_LINK_ERROR',
  recycler_bac_center_link_not_found_error: 'RECYCLER_BAC_CENTER_LINK_NOT_FOUND_ERROR',

  // REFERENCE API - RECYCLING BUYBACK PRICE
  recycling_buyback_price_invalid_product_boomerang_id_error:
    'RECYCLING_BUYBACK_PRICE_INVALID_PRODUCT_BOOMERANG_ID_ERROR',

  // REFERENCE API - REGION CODE
  region_code_not_found_error: 'REGION_CODE_NOT_FOUND_ERROR',
  region_code_invalid_country_name_error: 'REGION_CODE_INVALID_COUNTRY_NAME_ERROR',
  region_code_invalid_region_name_error: 'REGION_CODE_INVALID_REGION_NAME_ERROR',
  region_code_invalid_region_code_error: 'REGION_CODE_INVALID_REGION_CODE_ERROR',
  region_code_association_error: 'REGION_CODE_ASSOCIATION_ERROR',

  // REFERENCE API - RENTAL PRODUCT
  rental_product_not_found_error: 'RENTAL_PRODUCT_NOT_FOUND_ERROR',
  rental_product_invalid_availability_status_error:
    'RENTAL_PRODUCT_INVALID_AVAILABILITY_STATUS_ERROR',

  // REFERENCE API - REPAIR CENTER
  repair_center_not_found_error: 'REPAIR_CENTER_NOT_FOUND_ERROR',
  repair_center_invalid_repairer_error: 'REPAIR_CENTER_INVALID_REPAIRER_ERROR',

  // REFERENCE API - REPAIR CENTER LINK
  repair_center_link_not_found_error: 'REPAIR_CENTER_LINK_NOT_FOUND_ERROR',
  repair_center_link_invalid_repair_center_error: 'REPAIR_CENTER_LINK_INVALID_REPAIR_CENTER_ERROR',
  repair_center_link_invalid_network_error: 'REPAIR_CENTER_LINK_INVALID_NETWORK_ERROR',
  repair_center_link_invalid_key_account_network_error:
    'REPAIR_CENTER_LINK_INVALID_KEY_ACCOUNT_NETWORK_ERROR',
  repair_center_link_invalid_manufacturer_error: 'REPAIR_CENTER_LINK_INVALID_MANUFACTURER_ERROR',
  repair_center_link_invalid_category_error: 'REPAIR_CENTER_LINK_INVALID_CATEGORY_ERROR',
  repair_center_link_invalid_sub_category_error: 'REPAIR_CENTER_LINK_INVALID_SUB_CATEGORY_ERROR',
  repair_center_link_invalid_store_error: 'REPAIR_CENTER_LINK_INVALID_STORE_ERROR',
  repair_center_link_invalid_operating_center_error:
    'REPAIR_CENTER_LINK_INVALID_OPERATING_CENTER_ERROR',
  repair_center_link_manufacturer_not_linked_error:
    'REPAIR_CENTER_LINK_MANUFACTURER_NOT_LINKED_ERROR',
  repair_center_link_category_not_linked_error: 'REPAIR_CENTER_LINK_CATEGORY_NOT_LINKED_ERROR',
  repair_center_link_sub_category_not_linked_error:
    'REPAIR_CENTER_LINK_SUB_CATEGORY_NOT_LINKED_ERROR',
  repair_center_link_store_not_linked_error: 'REPAIR_CENTER_LINK_STORE_NOT_LINKED_ERROR',
  repair_center_link_operating_center_not_linked_error:
    'REPAIR_CENTER_LINK_OPERATING_CENTER_NOT_LINKED_ERROR',

  // REFERENCE API - OPERATING CENTER
  operating_center_invalid_rating_redirect_error: 'OPERATING_CENTER_INVALID_RATING_REDIRECT_ERROR',

  // REFERENCE API - REPAIRER
  repairer_not_found_error: 'REPAIRER_NOT_FOUND_ERROR',

  // REFERENCE API - STORE
  store_not_found_error: 'STORE_NOT_FOUND_ERROR',
  store_invalid_group_error: 'STORE_INVALID_GROUP_ERROR',
  store_invalid_region_code_error: 'STORE_INVALID_REGION_CODE_ERROR',
  store_invalid_manufacturer_error: 'STORE_INVALID_MANUFACTURER_ERROR',
  store_invalid_repairer_error: 'STORE_INVALID_REPAIRER_ERROR',
  store_invalid_repair_center_error: 'STORE_INVALID_REPAIR_CENTER_ERROR',
  store_invalid_rating_redirect_error: 'STORE_INVALID_RATING_REDIRECT_ERROR',
  store_invalid_siret_error: 'STORE_INVALID_SIRET_ERROR',
  store_erp_account_required_error: 'STORE_ERP_ACCOUNT_REQUIRED_ERROR',
  store_erp_store_beacon_code_required_error: 'STORE_ERP_STORE_BEACON_CODE_REQUIRED_ERROR',
  store_erp_store_beacon_code_invalid_error: 'STORE_ERP_STORE_BEACON_CODE_INVALID_ERROR',
  store_milwaukee_account_required_error: 'STORE_MILWAUKEE_ACCOUNT_REQUIRED_ERROR',
  store_milwaukee_password_required_error: 'STORE_MILWAUKEE_PASSWORD_REQUIRED_ERROR',

  // REFERENCE API - SUB CATEGORY
  sub_category_not_found_error: 'SUB_CATEGORY_NOT_FOUND_ERROR',
  sub_category_has_products_error: 'SUB_CATEGORY_HAS_PRODUCTS_ERROR',

  // REFERENCE API - TRANSPORT PACKAGE
  transport_package_not_found_error: 'TRANSPORT_PACKAGE_NOT_FOUND_ERROR',

  // REFERENCE API - TRANSPORTER
  transporter_not_found_error: 'TRANSPORTER_NOT_FOUND_ERROR'
}

export default ResponseConstant
